import React from 'react';
import clsx from 'clsx';
import styles from './UIGamePlayerInfoHeaderPointsPublic.module.scss';
import { getVPCircleColor, shouldUseBlackTextForPlayerColor } from '../../../UIGamePlayerInfoContainer/UIGamePlayerInfoContainerUtils.ts';
export const UIGamePlayerInfoHeaderPointsPublic = ({ points, playerColor })=>{
    const shouldUseBlackText = shouldUseBlackTextForPlayerColor(playerColor);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, {
            [styles.blackText]: shouldUseBlackText
        }),
        style: {
            '--color': getVPCircleColor(playerColor)
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.points
    }, points));
};
